module.exports = __webpack_public_path__ + "img/hohlschnitt_tieforange_ral2011.832e5f99.jpg";